export default __webpack_public_path__ + "f2486add5f9071eee4d58c585831547e.png";